import { render, staticRenderFns } from "./ListGroupMenu.vue?vue&type=template&id=0f8182f2&"
import script from "./ListGroupMenu.vue?vue&type=script&lang=js&"
export * from "./ListGroupMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports